import React, {Component} from 'react';
import DropZone from 'react-dropzone';
import {withStyles} from '@material-ui/core/styles';
import styles from './UploadDropArea.css';
import { Typography } from '@material-ui/core';
import classNames from 'classnames';

class UploadDropArea extends Component {

    onDrop = (acceptedFiles, rejectedFiles) => {
        this.props.updateFilesList( acceptedFiles.map(file => 
            Object.assign(file, {
                preview: URL.createObjectURL(file)
            })
        ));
        if (rejectedFiles.length>0){
            this.props.popupWarningSnackBar("You can upload only image files of size less than 20MB");
        }
    }

    render() {
        const {editable, classes} = this.props;
        return (
            <div className={classes.UploadDropArea}>
                <DropZone 
                    onDrop={this.onDrop}
                    accept="image/*"
                    maxSize={20000000}
                    disabled={!editable}
                >
                    {({getRootProps, getInputProps, isDragActive}) => (
                            <div className={classNames(
                                    classes.dropArea, 
                                    isDragActive ? classes.dropAreaHover : null
                                )} 
                                {...getRootProps()}>
                                <input {...getInputProps()} />
                                <Typography variant="h5" className={classes.dropAreaText}>
                                {
                                    isDragActive
                                        ? "Drop images" 
                                        : "Drop images here, or click to select images"
                                }
                                </Typography>
                            </div>
                    )}
                </DropZone>
            </div>
        );
    }
}

export default withStyles(styles, {withTheme: true})(UploadDropArea);
